let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jAsfE")).then(() => parcelRequire('l8NK5'));